const NavigationService = function ($state) {
  "ngInject"

  const go = to => $state.go(to)
  
  const isCurrent = page => $state.is(page)
  
  return { go, isCurrent };
};

export default NavigationService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/navigation.service.js
 **/